import { Helmet } from '@dr.pogodin/react-helmet';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import type CosmoDbContext from './lib/CosmoDbContext';
import { CosmoDbListDataType } from './lib/CosmoDbContext';
import CosmoDbListListView from './lib/CosmoDbListListView';
import CosmoDbListPageNavi from './lib/CosmoDbListPageNavi';
import CosmoDbListThumbnailView from './lib/CosmoDbListThumbnailView';
import CosmoDbListViewSwitcher from './lib/CosmoDbListViewSwitcher';

interface Props {
    lang: MultiLang;
    context: CosmoDbContext;
    params: URLSearchParams;
}

const CosmoDbList = (props: Props) => {
    const { lang, context, params } = props;
    const paramId = params.get('id');
    if (paramId === null || !/^\d+$/.test(paramId)) {
        return <PageNotFound lang={lang} />;
    }
    const id = parseInt(paramId, 10);
    const list = context.getList(id);
    if (list === null) {
        return <PageNotFound lang={lang} />;
    }
    const result = context.search(params);
    return (
        <div className="list">
            <Helmet>
                <title>
                    {Functions.mlang(context.getModuleName(), lang)} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <CosmoDbListViewSwitcher lang={lang} context={context} params={params} />
            <CosmoDbListPageNavi lang={lang} context={context} params={params} total={result.total} />
            <hr />
            {list.type === CosmoDbListDataType.List ? (
                <CosmoDbListListView lang={lang} context={context} list={list} params={params} data={result.result} />
            ) : (
                <CosmoDbListThumbnailView
                    lang={lang}
                    context={context}
                    list={list}
                    params={params}
                    data={result.result}
                />
            )}
            <CosmoDbListPageNavi lang={lang} context={context} params={params} total={result.total} />
        </div>
    );
};

export default CosmoDbList;
